import Localized from 'src/constants/AppStrings';
import Logo from 'src/components/elements/Logo';
import Styles from 'src/components/Styles';
import AramarkLogo from '../../../img/svg/AramarkLogo';
import React from 'react';

export function getLogoGradientProps() {
  return {
    colors: ['#A3DBE2', '#A3DBE2'],
    locations: [0, 1],
    start: {x: 0.5, y: 0},
    end: {x: 0.5, y: 1},
  };
}

export function getWelcomeLogoImage() {
  return <AramarkLogo />;
}

export function getLoginLogo(): JSX.Element {
  return <Logo width={126} height={126} />;
}

export function getWelcomeDescriptionText(): string {
  return Localized.Labels.welcome_text_aramark;
}

export function getWelcomeDescriptionTextStyle() {
  return {
    color: Styles.Colors.PayNew.black01,
    textAlign: 'center',
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 24,
  };
}

export function getLoginButtonColor() {
  return Styles.Colors.Aramark.primary;
}

export default {
  getLogoGradientProps,
  getWelcomeLogoImage,
  getLoginLogo,
  getWelcomeDescriptionTextStyle,
  getWelcomeDescriptionText,
  getLoginButtonColor,
};
